import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import CusFormField from 'components/CusFormField';
import useMain from 'hooks/useMain';
import React, { useEffect, useImperativeHandle, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

//checkbox round icon
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import _ from 'lodash';
import { Button1, Button2 } from 'components/Button';
import { SETTING_TYPE } from '../constant';
import { toDefaultDateFormat } from 'utils/common';

const SidebarForm = React.forwardRef(
  (
    {
      isSelection,
      title,
      rightTitle,
      fields = [],
      formData,
      handleSubmit: _handleSubmit = (data) => {},
      handleClear: _handleClear = () => {},
      handleChange: _handleChange = () => {},
      allDisabled,
      buttonLabel,
      clearButtonLabel,
      cusBottomComponent = () => null,
      showClearButton,
      showSubmitButton = true,
      showTitle = true,
      submitButtonProps = {},
      extraEventListener = () => {},
      workflowTitle,
      formsLayout = [],
      schema
    },
    ref
  ) => {
    const {
      control,
      setError,
      handleSubmit,
      getValues,
      setValue,
      formState: { errors },
      reset,
      watch
    } = useForm({
      resolver: schema ? yupResolver(schema) : null
    });

    useEffect(() => {
      if (_.isEmpty(formData) && _.isEqual(currentSettingType, SETTING_TYPE.GPSHISTORY)) {
        reset({ ...formData, CreatedDate: toDefaultDateFormat(new Date(), true) });
      } else {
        reset(formData);
      }

      return () => {
        reset({});
      };
    }, []);

    useImperativeHandle(
      ref,
      () => {
        return {
          setValue,
          getValues,
          reset
        };
      },
      []
    );

    const theme = useTheme();
    const { t, useSelector } = useMain();
    const _title = title || t('FILTERS');
    const _clearButtonLabel = clearButtonLabel || t('BTN_CLEAR');
    const _buttonLabel = buttonLabel || t('FILTER');
    const [selectedFields, setSelectedFields] = useState([]);
    const currentSettingType = useSelector((state) => state.comModule.settingType);

    return (
      <>
        <form
          autoComplete="off"
          id="sidebarForm"
          onSubmit={handleSubmit(
            (data) => {
              if (isSelection) {
                // include every activated field; empty → null so Modification/Multi still receives it
                const newData = Object.fromEntries(
                  selectedFields.map((key) => {
                    const v = data[key];
                    return [key, v === '' || v === undefined ? null : v];
                  })
                );
                _handleSubmit(newData);
                return;
              }
              _handleSubmit(data);
            },
            (err) => {}
          )}
        >
          <Stack p={3} spacing={2}>
            <Stack direction="row" justifyContent="space-between">
              {workflowTitle ? (
                <Stack direction="column" width="100%">
                  <Typography variant="body1">{workflowTitle}</Typography>
                  <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
                    {showTitle && (
                      <Typography variant="h4" sx={{ color: theme.palette.primary[400] }}>
                        {_title}
                      </Typography>
                    )}
                    {rightTitle && <Typography variant="body1">{rightTitle}</Typography>}
                  </Stack>
                </Stack>
              ) : (
                <>
                  {showTitle && (
                    <Typography variant="h4" sx={{ color: theme.palette.primary[400] }}>
                      {_title}
                    </Typography>
                  )}
                  {rightTitle && <Typography variant="h4">{rightTitle}</Typography>}
                </>
              )}
              {/* {showTitle && <Typography variant="h4" sx={{color:theme.palette.primary[400]}}>{_title}</Typography>}
              {rightTitle && <Typography variant="h4">{rightTitle}</Typography>} */}
            </Stack>
            {/* {!_.isEmpty(formsLayout) && renderLayout(formsLayout)} */}
            {fields.map((props) => {
              if (!props?.id) {
                return <></>;
              }
              //
              return (
                <Stack flexDirection="row" key={`${props?.id}-sidebar-formfield`} alignItems="flex-end">
                  {/* put it in front of custfield */}
                  {isSelection && (
                    <Checkbox
                      icon={<RadioButtonUncheckedIcon />}
                      checkedIcon={<CheckCircleIcon />}
                      checked={selectedFields.findIndex((id) => props?.id === id) > -1}
                      onChange={() => {
                        if (selectedFields.findIndex((id) => props?.id === id) > -1) {
                          setSelectedFields(selectedFields.filter((id) => id !== props?.id));
                          return;
                        }
                        setSelectedFields(selectedFields.concat(props?.id));
                      }}
                      // sx={{ marginTop: '20px' }}
                    />
                  )}
                  <CusFormField
                    {...props}
                    control={control}
                    fieldProps={{
                      autoComplete: 'new-password',

                      ...props?.fieldProps,
                      onChange: (e) => {
                        if (props?.fieldProps?.onChange) {
                          props?.fieldProps?.onChange(e);
                        }

                        _handleChange({ key: props?.id, value: e?.target?.value || e });
                      },
                      disabled:
                        allDisabled || props?.fieldProps?.disabled || isSelection
                          ? selectedFields.findIndex((id) => props?.id === id) === -1
                          : false
                    }}
                  />
                </Stack>
              );
            })}{' '}
          </Stack>
        </form>
        {(showSubmitButton || showClearButton) && (
          <Box
            p={2}
            display="flex"
            justifyContent="flex-end"
            sx={{
              bgcolor: 'white',
              width: '100%',
              position: 'sticky',
              bottom: 0,
              right: 0
            }}
          >
            {cusBottomComponent()}

            {showClearButton && (
              <Button2
                text={_clearButtonLabel}
                sx={{
                  mr: 2,
                  // borderRadius: '12px',
                  // ml: '10px',
                  width: 'calc(90% - 20px)'
                }}
                // size="medium"
                // variant="outlined"
                type="button"
                onClick={() => {
                  _handleClear();
                  reset({});
                }}
              />
            )}

            {showSubmitButton && (
              <Button1
                text={_buttonLabel}
                form="sidebarForm"
                // size="medium"
                // variant="contained"
                type="submit"
                sx={{
                  // borderRadius: '12px',
                  // width: `calc(100% - 20px)`,
                  width: showClearButton ? `calc(100% - 20px)` : '100%',
                  ...submitButtonProps?.sx
                }}
                {...submitButtonProps}
              />
            )}
          </Box>
        )}
      </>
    );
  }
);

export default SidebarForm;
